// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"5cfb84a1","986":"2aa08b0c","1661":"e591ec35","3553":"2aa08b0c","4405":"027a2115","6096":"94ca98ff","7359":"2aa08b0c","8182":"96d24104"}[chunkId] + ".chunk.css";
};